import { GetExtension } from "./GetExtension.js";

export function LoadFileAsXML(fileName) {
  var fileExt = GetExtension(fileName);
  return fileExt == "oc5" || fileExt == "oc5m";
}
